module.exports = "//public.getcloudapp.com/packs/media/images/buttons-add-new-collection-sidebar-422b2444fc78f068bc2a787da5abc383.svg";